var map = {
	"./customize_cn.png": 394,
	"./customize_en.png": 395,
	"./giant_paper_straw1.png": 396,
	"./giant_paper_straw2.png": 397,
	"./giant_paper_straw3.png": 398,
	"./giant_paper_straw4.png": 399,
	"./giant_paper_straw5.png": 400,
	"./pla_black_cocktail_straw1.png": 401,
	"./pla_black_cocktail_straw2.png": 402,
	"./pla_black_cocktail_straw3.png": 403,
	"./pla_clear_angel_cut_straw1.png": 404,
	"./pla_clear_angel_cut_straw2.png": 405,
	"./pla_clear_angel_cut_straw3.png": 406,
	"./pla_clear_gaint_straw1.png": 407,
	"./pla_clear_gaint_straw2.png": 408,
	"./pla_clear_gaint_straw3.png": 409,
	"./pla_clear_green_stripes_straw1.png": 410,
	"./pla_clear_green_stripes_straw2.png": 411,
	"./pla_clear_green_stripes_straw3.png": 412,
	"./pla_clear_strew1.png": 413,
	"./pla_clear_strew2.png": 414,
	"./pla_clear_strew3.png": 415,
	"./pla_green_gaint_straw1.png": 416,
	"./pla_green_gaint_straw2.png": 417,
	"./pla_green_gaint_straw3.png": 418,
	"./pla_green_strew1.png": 419,
	"./pla_green_strew2.png": 420,
	"./pla_green_strew3.png": 421,
	"./pla_white_strew1.png": 422,
	"./pla_white_strew2.png": 423,
	"./pla_white_strew3.png": 424,
	"./pp_clear_bendable_straw1.png": 425,
	"./pp_clear_bendable_straw2.png": 426,
	"./pp_clear_bendable_straw3.png": 427,
	"./pp_clear_gaint_straw1.png": 428,
	"./pp_clear_gaint_straw2.png": 429,
	"./pp_clear_gaint_straw3.png": 430,
	"./pp_colored_gaint_straw1.png": 431,
	"./pp_colored_gaint_straw2.png": 432,
	"./pp_colored_gaint_straw3.png": 433,
	"./pp_regular_paper_straw_black1.png": 434,
	"./pp_regular_paper_straw_black2.png": 435,
	"./pp_regular_paper_straw_black3.png": 436,
	"./pp_regular_paper_straw_green1.png": 437,
	"./pp_regular_paper_straw_green2.png": 438,
	"./pp_regular_paper_straw_green3.png": 439,
	"./regular_paper_straw_black1.png": 440,
	"./regular_paper_straw_black2.png": 441,
	"./regular_paper_straw_black3.png": 442,
	"./regular_paper_straw_white1.png": 443,
	"./regular_paper_straw_white2.png": 444,
	"./regular_paper_straw_white3.png": 445,
	"./smoothie_paper_straw1.png": 446,
	"./smoothie_paper_straw2.png": 447,
	"./smoothie_paper_straw3.png": 448
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 393;